import click from '@mailobj-browser/front/js/events/types/click.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import * as lightbox from '../../lightboxes/lightbox.js'
import { close } from '../../lightboxes/menus/menu.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import { insert } from "../rte.js"
import closest from "@mailobj-browser/front/js/selectors/closest.js"
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    button
  ) => {
    const library = closest('[data-contract="menu.library"]', button)
    const origin = lightbox.opener(library)
    const form = closest('form', origin)
    const rte = one('iframe[data-rte]', form)

    close()

    if (rte) {
      insert(rte.id, button.value)
    }
  }
})

export default button => {
  onClick.listen(button)
}